import React, {useState} from "react";
import UploadIcon from '../../../assets/icons/import-icon-blue-light.svg'
import { requestDataWithFile } from "../../../helper/request";
import Swal from "sweetalert2";

export default function UploadDocument({ payrollId, payrollDocument, deletePayrollDocument, payrollStatus, loadData, approveFile, setApproveFile, ...props }){
    const [loading, setLoading] = useState(false);
    const isFinished = payrollStatus === 'finish';

    const handleSubmit = async () => {
        if (isFinished) {
            return;
        }
        setLoading(true);
        let form;
        if (approveFile) {
            form = new FormData();
            form.append('payroll_id', payrollId);
            form.append('file', approveFile);

            const response = await requestDataWithFile("payroll/document-add", form);
            if (response.success) {
                loadData();
                Swal.fire({
                    title: 'Berhasil!',
                    text: response.message,
                    icon: 'success',
                    showConfirmButton: false,
                    timer: 1500,
                });
            } else {
                Swal.fire({
                    title: 'Gagal!',
                    text: response.error || response.message || "Terjadi kesalahan saat mengunggah dokumen."    ,
                    icon: 'error',
                    confirmButtonText: 'OK'
                });
            }
        } else {
            Swal.fire({
                title: 'Gagal!',
                text: "Belum Pilih Dokumen atau Foto",
                icon: 'error',
                confirmButtonText: 'OK'
            });
        }

        setLoading(false);
    };

    const PreviewFile = ({ name, size, isImage, previewUrl, onRemove, disabled }) => (
        <div className="mb-3 p-3 bg-success-light border border-success rounded">
            <div className="d-flex justify-content-between align-items-center">
                <a
                    href={previewUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="d-flex align-items-center"
                >
                    {isImage ? (
                        <img
                            src={previewUrl}
                            alt="preview"
                            className="rounded mr-3"
                            style={{ width: "50px", height: "50px", objectFit: "cover" }}
                        />
                    ) : (
                        <div className="bg-primary text-white d-flex align-items-center justify-content-center rounded mr-3" style={{ width: "50px", height: "50px" }}>
                            PDF
                        </div>
                    )}

                    <div>
                        <p className="mb-0 font-weight-bold text-dark">
                            {name}
                        </p>
                        <small className="text-muted">{size}</small>
                    </div>
                </a>

                {!disabled && (
                    <button
                        type="button"
                        onClick={onRemove}
                        className="btn btn-sm btn-outline-danger"
                    >
                        <i className="fa fa-times"></i>
                    </button>
                )}
            </div>
        </div>
    );

    if (isFinished) {
        return (
            <div className="card">
                <div className="card-body">
                    <h5 className="card-title">Unggah Slip</h5>
                    <p className="text-muted">Upload tidak tersedia, payroll telah selesai.</p>
                    {payrollDocument && (
                        <PreviewFile
                            name={payrollDocument.payroll_doc_file}
                            size={"Sudah terupload"}
                            isImage={payrollDocument.payroll_doc_file?.match(/\.(jpg|jpeg|png)$/)}
                            previewUrl={payrollDocument.file_url}
                            disabled={true}
                        />
                    )}
                </div>
            </div>
        );
    }

    return (
        <div className="card">
            <div className="card-body">
                <h5 className="card-title">
                    Unggah Slip
                </h5>
                <div>
                    { !approveFile && !payrollDocument ? (
                        <div>
                            <input
                                type="file"
                                id="approveFile"
                                accept=".pdf,.jpg,.jpeg,.png"
                                onChange={(e) => {
                                    const file = e.target.files?.[0];
                                    if (file) setApproveFile && setApproveFile(file);
                                }}
                                className="d-none"
                            />
                            <label
                                htmlFor="approveFile"
                                className="d-flex flex-column align-items-center justify-content-center p-5 border border-dashed border-secondary rounded cursor-pointer hover-border-primary hover-bg-light"
                                style={{ cursor: "pointer" }}
                            >
                                <img src={UploadIcon} alt="Upload" className="mb-2" style={{ height: "24px", width: "24px" }} />
                                <p className="mb-1 font-weight-medium text-muted">
                                    Pilih dokumen atau foto
                                </p>
                                <small className="text-muted">
                                    PDF, JPG, PNG
                                </small>
                            </label>
                        </div>
                    ) : approveFile ? (
                        <PreviewFile
                            name={approveFile.name}
                            size={(approveFile.size / 1024).toFixed(2) + " KB"}
                            isImage={approveFile?.type?.startsWith("image/")}
                            previewUrl={URL.createObjectURL(approveFile)}
                            onRemove={() => setApproveFile && setApproveFile(null)}
                        />
                    ) : (
                        <PreviewFile
                            name={payrollDocument.payroll_doc_file}
                            size={"Sudah terupload"}
                            isImage={payrollDocument.payroll_doc_file?.match(/\.(jpg|jpeg|png)$/)}
                            previewUrl={payrollDocument.file_url}
                            onRemove={() => deletePayrollDocument(null)}
                        />
                    )}
                </div>
                <div className="d-flex justify-content-end mt-3">
                    <button
                        className="btn btn-primary uppercase"
                        onClick={handleSubmit}
                        disabled={loading || approveFile === null}
                    >
                        Unggah
                    </button>
                </div>
            </div>
        </div>
    )
}